import { Map } from 'immutable';
import { actionTypes as trucksSensorsViewActions } from '../../../actions/Administration/SettingsPage/trucksSensorsViewActions';

let defaultState = {
  loading: false,
};

export default function (state = Map(defaultState), action) {
  switch (action.type) {
    default:
      return state;
  }
}
